export const invitation = {
  weddingAt: '2026-11-21T11:00:00+09:00',
  venue: {
    name: '그랜드 모먼트',
    hall: 'B2 화이트 홀',
    address: '부산광역시 남구 황령대로 401-9',
    addressForCopy: '부산광역시 남구 황령대로 401-9 그랜드 모먼트',
    lat: 35.1455935,
    lng: 129.1002661,
  },
  couple: {
    groom: { name: '우석', fullName: '장우석', parents: '장영일 · 양미숙', relation: '의 장남' },
    bride: { name: '유나', fullName: '박유나', parents: '박균수 · 김경숙', relation: '의 장녀' },
  },
  greeting: [
    '서로에게 별처럼 빛나는 사람을 만나',
    '평생을 약속하려 합니다.',
    '두 사람이 한 빛으로 살아가는 첫날,',
    '오셔서 따뜻한 축복으로 함께해 주세요.',
  ],
  transit: [
    { label: '지하철', text: '남천역 4번 출구에서 1km 이내' },
    { label: '버스', text: '38번 · 583번, 동원 보라아파트 하차' },
  ],
  mapApps: [
    { label: '네이버 지도', href: 'https://map.naver.com/p/search/부산 그랜드 모먼트' },
    { label: '카카오맵', href: 'https://map.kakao.com/link/search/부산 그랜드 모먼트' },
    { label: '티맵', href: 'tmap://search?name=그랜드모먼트' },
  ],
  carApps: [
    { label: '현대', app: '현대 블루링크' },
    { label: '기아', app: '기아 커넥트' },
    { label: '벤츠', app: 'Mercedes me' },
    { label: 'BMW', app: 'My BMW' },
  ],
  gallery: { initialCount: 7 },
  snap: {
    title: '하객 스냅 보내기',
    body: ['여러분의 시선으로 담아 주신 순간도', '저희에게는 큰 선물이에요. 사진을 공유해 주세요.'],
    hint: '예식 시작부터 업로드할 수 있어요',
  },
} as const
